import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Spinner } from '@/components/ui/spinner';
import Navbar from './Navbar';
import GlobalModals from '../GlobalModals';
import { useAuth } from '../../contexts/AuthContext';
import { useUIStore } from '../../stores/uiStore';

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0 },
};

const pageTransition = {
  type: 'tween' as const,
  ease: 'easeOut' as const,
  duration: 0.2,
};

export default function MainLayout() {
  const { isAuthenticated } = useAuth();
  const openCommitEditor = useUIStore((s) => s.openCommitEditor);
  const location = useLocation();

  return (
    <div className="min-h-screen">
      <Navbar onNewCommit={isAuthenticated ? () => openCommitEditor() : undefined} />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={pageVariants}
          transition={pageTransition}
        >
          <Suspense fallback={
            <div className="flex items-center justify-center py-20">
              <Spinner size="lg" />
            </div>
          }>
            <Outlet />
          </Suspense>
        </motion.div>
      </AnimatePresence>

      <GlobalModals />
    </div>
  );
}
